import { Spinner as InternalSpinner } from '@lessonnine/design-system.lib'
import { CURRENT_DS_VERSION } from 'src/dataLayer/localData/designSystem'
import { DS_VERSIONS } from 'src/dataLayer/localData/designSystem/versions'

const Spinner = {
  [DS_VERSIONS.default]: InternalSpinner,
}

export default Spinner[CURRENT_DS_VERSION]
